import './CourseCard.css';

const CourseCard = ({ image, title }) => {
  return (
    <div className="course-card">
      <div className="course-card__image-container">
        <img 
          src={image} 
          alt={title} 
          className="course-card__image" 
        />
      </div>
      <div className="course-card__content">
        <h3 className="course-card__title">
          {title}
        </h3>
      </div>
    </div>
  );
};

export default CourseCard;